// @flow
import React, { useContext } from "react";
import { MultiSelectionContext } from "data/context";
import Icons from "@hs/icons";
import { BrowserDragLink } from "components/ItemUriLink";
import ValueFactory from "components/Attributes/SummaryAttribute/ValueFactory";
import Mark from "@hs/mark";
import {
    GridListConstant,
    SearchValueType,
    SummaryAttributeValueType,
} from "data/types";
import withStickyToggle from "containers/StickyToggle";
import StickyToggleStyle from "containers/StickyToggle/style";
import { isHandheld } from "data/bowser";
import { getClassNames } from "data/utils";
import styles from "./CellContent.module.css";

type Props = {
    col: DocColumnResultDTO,
    cell: any,
    filterText: any,
    onMoreClick: (
        e: SyntheticMouseEvent,
        itemUri: string,
        index: number
    ) => void,
    actionsDisabled: boolean,
    itemUri: string,
};

export const CellContent = ({ index, cell, col, isHovered }: Props) => {
    /* istanbul ignore next */
    const { multiple, renderCheckbox } = useContext(MultiSelectionContext) || {
        multiple: false,
        renderCheckbox: () => null,
    };
    let content = cell && cell.value;
    if (col.name === GridListConstant.ExtensionIcon) {
        if (multiple && isHandheld()) {
            content = renderCheckbox(index, styles.checkbox);
        } else {
            content = (
                <>
                    {(isHovered || multiple) &&
                        !isHandheld() &&
                        renderCheckbox(
                            index,
                            getClassNames(styles.checkbox, styles.desktop)
                        )}
                    {cell.isDoc ? (
                        <BrowserDragLink
                            itemUri={cell.itemUri}
                            className={getClassNames(
                                styles.link,
                                !isHandheld() && styles.desktop
                            )}
                        >
                            <Icons.Custom
                                ext={cell.ext}
                                icon={cell.icon}
                                color={cell.color}
                                className={styles.icon}
                            />
                        </BrowserDragLink>
                    ) : (
                        <Icons.Custom
                            elementType={cell.elementType}
                            icon={cell.icon}
                            color={cell.color}
                            className={getClassNames(
                                styles.icon,
                                styles.link,
                                !isHandheld() && styles.desktop
                            )}
                        />
                    )}
                </>
            );
        }
    } else if (SearchValueType[col.type] === SearchValueType.Link) {
        return (
            <ValueFactory
                value={content || { $type: SummaryAttributeValueType.TextLink }}
                className={`a-val ${SummaryAttributeValueType.TextLink}--grid`}
            />
        );
    } else if (content == null) {
        return null;
    } else if (Object.prototype.hasOwnProperty.call(content, "$type")) {
        return (
            <ValueFactory
                value={content}
                className={`a-val ${content.$type}--grid`}
            />
        );
    }
    return (
        <Mark
            className={styles.mark}
            word={cell.foundTerms.map((term) => term.replace("*", ""))}
        >
            {content}
        </Mark>
    );
};

const CellContentWithStickyToggle = withStickyToggle({
    getStyle: StickyToggleStyle.GridList,
    renderDiv: true,
    portalTargetSelector:
        "#searchResult .ReactVirtualized__Grid__innerScrollContainer",
})(CellContent);

export default CellContentWithStickyToggle;
